<template>
  <div class='tooltip' role='tooltip'>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'x-tooltip'
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .tooltip {
    position: absolute;
    background: $color-shark;
    color: white;
    padding: 0.8rem;
    border-radius: 3px;
    font-weight: 600;
    font-size: 1.4rem;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 300ms $extra-ease-out, transform 300ms $extra-ease-out, visibility 300ms;

    &:before {
      content: '';
      border: solid transparent;
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba($color-shark, 0);
      border-width: 6px;
    }

    &.on-right {
      transform: translate(25%, -50%);
      margin-left: $space-small;
      left: 100%;
      top: 50%;

      &:before {
        right: 100%;
        top: 50%;
        border-right-color: $color-shark;
        margin-top: -0.6rem;
      }
    }

    &.on-bottom {
      top: 100%;
      left: 50%;
      margin-top: $space-small;
      transform: translate(-50%, 25%);

      &:before {
        left: 50%;
        margin-left: -0.6rem;
        bottom: 100%;
        border-bottom-color: $color-shark;
      }
    }
  }

  .tooltip-container {
    position: relative;

    &:hover {
      .tooltip {
        opacity: 1;
        visibility: visible;

        &.on-right {
          transform: translate(0, -50%);
        }

        &.on-bottom {
          transform: translate(-50%, 0);
        }
      }
    }
  }
</style>
